export const NotificationType = {
    NORMAL: 1,
    GEOFENCING: 2
};
